import { useState, FC, useEffect } from 'react';
import { useSendTaskMutation } from '../../api/tenders';
import { tenderDataProps } from '../../pages/TenderViewPage/types';
import { useAppSelector } from '../../hooks';
import { Button, Tooltip, message } from 'antd';

import arrow from '../../assets/arrow-right-white.svg';
import attention from '../../assets/attention.svg';
import Rocket from '../../assets/Rocket.svg';
import calendar from '../../assets/calendar-chedule.svg';

import moment from 'moment';
import './phases.scss';
import { SupplierListNew } from './DesignPhaseComponents/SupplierListNew';
import { RegistrationClosingDate } from './LaunchPhaseComponents/RegistrationClosingDate';
import { NextPhaseModal } from './LaunchPhaseComponents/NextPhaseModal';

interface PropsPhase {
    data: tenderDataProps;
    setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
    setConfirmModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LaunchPhase: FC<PropsPhase> = ({ data, setTrigger, setConfirmModal }) => {
    const { role } = useAppSelector((state) => state.profileReducer);
    const [screenWidth, setScreenWidth] = useState<number>(window.screen.width);
    function handleResize() {
        setScreenWidth(window.screen.width);
    }
    window.addEventListener('resize', handleResize);
    const [nextPhaseModal, setNextPhaseModal] = useState(false);

    const [
        sendTask,
        { data: dataSendTask, isError: isErrorSendTask, isSuccess: isSuccessSendTask, isLoading: isLoadingSendTask }
    ] = useSendTaskMutation();

    const [messageApi, contextHolder] = message.useMessage();

    const moveToEvaluatePhase = async () => {
        if (!data?.can_update_phase) return;

        const participating = data?.invited_suppliers?.items?.filter((elem) => {
            if (elem.registration_status === 'registered') {
                return elem;
            }
        });

        const addedByBuyer = data?.invited_suppliers?.items?.filter((elem) => {
            if (elem.company.is_candidate && elem.status === 'invited') {
                return elem;
            }
        });

        if (participating.length < 10 || addedByBuyer?.length) {
            setNextPhaseModal(true);
            return;
        } else {
            setConfirmModal(true);
        }
    };

    const sendTaskFunc = async () => {
        let formData = {};

        formData = {
            id: data?.id
        };
        try {
            await sendTask(formData).unwrap();
            await setTrigger((prev: boolean) => !prev);
        } catch {}
    };

    useEffect(() => {
        if (isErrorSendTask) {
            messageApi.error('Something went wrong, please try again');
        }
        if (isSuccessSendTask) {
            messageApi.success(dataSendTask.message);
        }
    }, [isErrorSendTask, isSuccessSendTask]);

    const taskHeaderDeadlineAt = role === 'school_user' ? data?.tasks_deadline_at : data?.phase_deadline_at;

    return (
        <>
            {contextHolder}
            <div className={`tendermain__block tasks`}>
                <div className="tasks__header define">
                    <div className="count-wrapper">
                        Task Centre
                        <div className="count">{data?.phase_task_count}</div>
                    </div>
                    {taskHeaderDeadlineAt && (
                        <div className="tasks__deadline-wrapper">
                            <img src={attention} alt="" />
                            Task Deadline - {moment(taskHeaderDeadlineAt).format('YYYY-MM-DD')}
                        </div>
                    )}
                </div>

                <div className="tasks__list">
                    <RegistrationClosingDate data={data} role={role} messageApi={messageApi} setTrigger={setTrigger} />
                    <SupplierListNew data={data} role={role} setTrigger={setTrigger} messageApi={messageApi} />

                    {role === 'school_user' &&
                        (data.tasks_deadline_at ? (
                            <div className="noTasks">
                                <img src={Rocket} />
                                <div className="noTasks__title">Matchmaking Journey has been reviewed</div>
                                <div className="noTasks__subtitle">
                                    Suppliers are busy preparing their proposals. We will back to you with their
                                    proposals after deadline
                                </div>
                                <div className="noTasks__date">
                                    <img src={calendar} className="noTasks__image" />{' '}
                                    {moment(data.tasks_deadline_at).format('DD MMMM, YYYY')}
                                </div>
                            </div>
                        ) : (
                            <div className="noTasks">
                                <img src={Rocket} />
                                <div className="noTasks__title">Welcome to Review Phase!</div>
                                <div className="noTasks__subtitle">
                                    Watch this space - new tasks for you will be posted here as they become available.
                                </div>
                            </div>
                        ))}
                </div>

                {role === 'tender_representative' &&
                    data?.phase_tasks?.find((elem) => elem.action === 'launch_tender_date')?.status !== 'completed' && (
                        <div className="tasks__btn-wrap">
                            <div></div>

                            <Tooltip
                                title="To send this task, you need to complete all the Task Activities"
                                overlayClassName={` ${
                                    !data?.can_send_task ? 'custom-tooltip-disabled' : 'custom-tooltip'
                                }`}
                            >
                                <Button
                                    className={`tasks__next-btn ${data?.can_send_task ? '' : 'disabled'}`}
                                    type="primary"
                                    style={{ width: '180px' }}
                                    onClick={() => {
                                        if (!data?.can_send_task) {
                                            return;
                                        } else {
                                            if (!isLoadingSendTask) {
                                                sendTaskFunc();
                                            }
                                        }
                                    }}
                                >
                                    Notify Suppliers <img src={arrow} />
                                </Button>
                            </Tooltip>
                        </div>
                    )}

                {role === 'tender_representative' &&
                    data?.phase_tasks?.find((elem) => elem.action === 'launch_tender_date')?.status === 'completed' && (
                        <div className="tasks__btn-wrap">
                            <div></div>
                            <Tooltip
                                title={
                                    data?.can_update_phase
                                        ? ''
                                        : 'To send this task, you need to complete all the Task Activities'
                                }
                            >
                                <Button
                                    className={`tasks__next-btn ${data?.can_update_phase ? '' : 'disabled'}`}
                                    type="primary"
                                    style={{ width: '220px' }}
                                    onClick={() => moveToEvaluatePhase()}
                                >
                                    Start Evaluate Phase <img src={arrow} />
                                </Button>
                            </Tooltip>
                        </div>
                    )}
            </div>
            {nextPhaseModal && (
                <NextPhaseModal
                    openModal={nextPhaseModal}
                    setOpenModal={setNextPhaseModal}
                    setTrigger={setTrigger}
                    tenderData={data}
                    setConfirmModal={setConfirmModal}
                />
            )}
        </>
    );
};
